import { CURRENCIES, CurrencyCode } from '../../core/data/currencies';
import { DropdownOption } from '../models/form-controls.model';

export const CURRENCY_OPTIONS: DropdownOption<CurrencyCode>[] = CURRENCIES.map(
  c => ({
    label: c.label,
    value: c.code,
  })
);
